
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About: React.FC = () => {
  return (
    <section id="about" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4">About Me</h2>
        <Row className="justify-content-center">
          <Col md={8}>
            <p>
              From Moldova. Worked in IT since 2003 in various roles, started from System Administrator and during 20 years grown up to CTO managing 95 engineers (ex-Paxful). Infrastructure Engineer by profession with experience in AWS, Kubernetes, GitLab, Terraform, Python. <br></br> AI practicioner and enthusiast.            </p>
            <p>
              Here is how I can assist you:
              <ol>
                <li>Build software engineering organization from scratch with the focus on fast deliverables, high software quality, and profit and loss optimization.</li>
                <li>Establish continuous delivery framework in the existing projects, transform the current development process, tools and software design to allow working through short release cycle to bring high value features to market in short term.</li>
                <li>Arrange work through innovations: introduce new technologies, reduce of technical debt in the software, protect intellectual property with patent work.</li>
                <li>Get rid of weak points in the engineering processes, adjust and introduce the best practices for project management taking into account team's mentality and company's values, reduce business risks.</li>
                <li>Introduce the best practices in test methods and tools taking into account the current engineering process. Build a culture in engineering team to focus on developing high quality software.</li>
                <li>Build/revise engineering team to have high efficient and effective functions teams, hire talents and develop competences for engineering staff on all levels (build a competence model, hiring, manage team growth, build/adjust systems for performance review and team motivation).</li>
                <li>Arrange collaboration with outsourcing companies, work on legal aspects, implement a certification program for software developed by third parties.</li>
              </ol>
            </p>
            <p>
              I am passionate about helping you improve your tech for faster, high-quality, and profitable results!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
